const KEY = 'amposter:tasbeeh:level-vibration';
const DURATION_KEY = 'amposter:tasbeeh:vibration-duration';
export const TASBEEH_VIBRATION_DURATIONS = [1000,1500,2000];
export function readTasbeehVibrationDuration() {
  try { const value=Number(localStorage.getItem(DURATION_KEY));return TASBEEH_VIBRATION_DURATIONS.includes(value)?value:1500; } catch { return 1500; }
}
export function saveTasbeehVibrationDuration(value) {
  if (TASBEEH_VIBRATION_DURATIONS.includes(value)) try { localStorage.setItem(DURATION_KEY,String(value)); } catch {}
}
export function vibrateTasbeeh(enabled = readTasbeehVibration(), duration = readTasbeehVibrationDuration()) {
  if (!enabled || document.hidden) return;
  try { navigator.vibrate?.(TASBEEH_VIBRATION_DURATIONS.includes(duration)?duration:1500); } catch {}
}

export function readTasbeehVibration() {
  try { return localStorage.getItem(KEY) !== 'false'; } catch { return true; }
}

export function saveTasbeehVibration(enabled) {
  try { localStorage.setItem(KEY, String(enabled)); } catch { /* Preference remains usable for this view. */ }
}

export function vibrateTasbeehLevel(before, after, goal, enabled = readTasbeehVibration(), duration = readTasbeehVibrationDuration()) {
  const level = count => Math.min(40, Math.floor(count / Math.max(10, goal)) + 1);
  if (!enabled || !Number.isFinite(before) || !Number.isFinite(after) || !Number.isFinite(goal) || level(after) <= level(before) || document.hidden) return;
  vibrateTasbeeh(enabled,duration);
}
